import script from "./PersonalColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalColor.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalColor.vue?vue&type=style&index=0&id=184327b5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184327b5"]])

export default __exports__